// extracted by mini-css-extract-plugin
export var card = "_8a-0";
export var expandedCard = "_8a-2";
export var paginated = "_8a-1";